import React from 'react';
import { kebabCase } from 'lodash';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import Popper from '@material-ui/core/Popper';
import { CardContent } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import CardHeader from '@material-ui/core/CardHeader';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { withRouter } from 'react-router';

import styles from './styles';

const propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      action: PropTypes.func,
    }),
  ).isRequired,
  // Boundaries used by Popper.js modifier
  boundariesElement: PropTypes.oneOfType([
    PropTypes.oneOf(['scrollParent', 'window', 'viewport']),
    PropTypes.instanceOf(Element),
  ]),
  classes: PropTypes.shape({
    popper: PropTypes.string,
    arrow: PropTypes.string,
    menuItem: PropTypes.string,
    cardHeaderRoot: PropTypes.string,
    cardHeaderTitle: PropTypes.string,
    cardHeaderAction: PropTypes.string,
    closeActionsPopoverButton: PropTypes.string,
    cardContentRoot: PropTypes.string,
  }).isRequired,
  history: PropTypes.object.isRequired,
};

const defaultProps = {
  boundariesElement: 'scrollParent',
};

export class ActionsButton extends React.Component {
  constructor(props) {
    super(props);

    this.arrowRef = React.createRef();
    this.state = {
      isPopoverOpen: false,
      anchorEl: null,
    };
  }

  handleActionsButtonClick = evt => {
    if (!this.state.anchorEl) {
      this.setState({
        anchorEl: evt.currentTarget,
      });
    }

    this.setState(prevState => ({
      isPopoverOpen: !prevState.isPopoverOpen,
    }));
  };

  handleCloseActionsButtonClick = () => {
    this.setState({
      isPopoverOpen: false,
    });
  };

  render() {
    const {
      classes,
      actions,
      title,
      id,
      boundariesElement,
      history,
    } = this.props;
    const { isPopoverOpen, anchorEl } = this.state;

    return (
      <>
        <Popper
          className={classes.popper}
          open={isPopoverOpen}
          anchorEl={anchorEl}
          placement="bottom-end"
          modifiers={{
            flip: {
              enabled: true,
            },
            arrow: {
              enabled: true,
              element: this.arrowRef.current,
            },
            preventOverflow: {
              enabled: true,
              boundariesElement,
            },
          }}
        >
          <span className={classes.arrow} ref={this.arrowRef} />
          <Card>
            <CardHeader
              classes={{
                root: classes.cardHeaderRoot,
                title: classes.cardHeaderTitle,
                action: classes.cardHeaderAction,
              }}
              title={title}
              action={
                <IconButton
                  className={classes.closeActionsPopoverButton}
                  aria-label="Close Actions Popover"
                  onClick={this.handleCloseActionsButtonClick}
                  id={`${id}-actions-popover-close-button`}
                >
                  <CloseIcon />
                </IconButton>
              }
            />
            <CardContent className={classes.cardContentRoot}>
              <MenuList data-test="actions-list">
                {actions.map(item => (
                  <MenuItem
                    key={item.label}
                    id={`${id}-${kebabCase(item.label)}`}
                    className={classes.menuItem}
                    onClick={() => {
                      item.action(history);
                      this.handleCloseActionsButtonClick();
                    }}
                    data-test="action-item"
                  >
                    {item.label}
                  </MenuItem>
                ))}
              </MenuList>
            </CardContent>
          </Card>
        </Popper>
        <IconButton
          className={classes.actionsToggleButton}
          aria-label="More Actions"
          onClick={this.handleActionsButtonClick}
          data-test="actions-toggle-button"
          id={`${id}-actions-toggle-button`}
        >
          <MoreHorizIcon />
        </IconButton>
      </>
    );
  }
}

ActionsButton.propTypes = propTypes;
ActionsButton.defaultProps = defaultProps;

export default withRouter(withStyles(styles)(ActionsButton));
